import { useCallback, useMemo, useRef, useState } from 'react';
import { ladeOrdnerBaum, type BaumKnoten } from '../../../../lib/dokumente/aktenschrankApi';

/** Ordnerbäume je Objekt, einmal geladen und von allen Karten geteilt. */
export interface OrdnerQuelle { liste: (objektId: string | null) => BaumKnoten[] | null; lade: (objektId: string) => void }

export function useOrdnerQuelle(): OrdnerQuelle {
  const [baeume, setBaeume] = useState<ReadonlyMap<string, BaumKnoten[]>>(new Map());
  const unterwegs = useRef(new Set<string>());
  const lade = useCallback((objektId: string) => {
    if (unterwegs.current.has(objektId)) return;
    unterwegs.current.add(objektId);
    ladeOrdnerBaum(objektId)
      .then(b => setBaeume(alt => new Map(alt).set(objektId, b)))
      .catch(() => { unterwegs.current.delete(objektId); });
  }, []);
  return useMemo(() => ({ liste: (id: string | null) => (id ? baeume.get(id) ?? null : null), lade }), [baeume, lade]);
}
